import { VerticalCenter } from "@/common/css";
import RenderFormForModal from "@/components/Form/Renderer/RenderFormForModal";
import { FormUIContext } from "@/context";
import { addUpdateSignatory } from "@/services/common/profile.services";
import { AddSignatoryConfig } from "@/utils/constant/formConfig.constant";
import { toastMessage } from "@/utils/helper/myToast";
import React, { useState } from "react";

interface AddSignatoryModalProps {
  onClose: (props?: any) => void;
  data?: any;
}

const AddSignatoryModal: React.FC<AddSignatoryModalProps> = ({ onClose, data }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);

  const handleSubmit = async (data: any) => {
    if (data?.authorizedDoc?.previewUrl) {
      delete data.authorizedDoc.previewUrl;
    }
    const res: any = await addUpdateSignatory(data);
    if (res?.status === 200) {
      const { message, isError, showMessage } = res.data;
      onClose({ disabledWarning: true });
      if (showMessage) return toastMessage(message, isError);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
    }
  };
  // console.log({ data });
  return (
    <VerticalCenter className="h-full">
      <FormUIContext.Provider value={{ isFormLoading, setIsFormLoading }}>
        <RenderFormForModal
          handleFormSubmit={handleSubmit}
          handleCancel={onClose}
          formConfig={AddSignatoryConfig}
          className="w-full h-full"
          btnContainerClass="!p-4 sticky bottom-0 bg-white"
          formClassName="h-[calc(100%-186px)]"
          defaultValues={data}
        />
      </FormUIContext.Provider>
    </VerticalCenter>
  );
};

export default AddSignatoryModal;
